import { type ComponentPropsWithRef } from "react";
import {
  Root as PopoverPrimitiveRoot,
  Trigger as PopoverPrimitiveTrigger,
  Anchor as PopoverPrimitiveAnchor,
  Portal as PopoverPrimitivePortal,
  Content as PopoverPrimitiveContent,
} from "@radix-ui/react-popover";

import { PaperFloating } from "@/components/atoms/paperFloating";
import { DROPDOWN_PANEL_SHELL_CLASS } from "@/components/molecules/dropdownPanel/dropdownPanel";
import { DropdownPanelScrollBody } from "@/components/molecules/dropdownPanel/dropdownPanelScrollBody";
import { cn } from "@/lib/utils";
import { RADIX_CONTENT_ANIMATION_CLASSES } from "@/lib/ui/radixContentClasses";

const Popover = PopoverPrimitiveRoot;

const PopoverTrigger = PopoverPrimitiveTrigger;

const PopoverAnchor = PopoverPrimitiveAnchor;

const PopoverContent = ({
  className,
  align = "center",
  sideOffset = 4,
  dropdownPanel = false,
  dropdownPanelScrollable = false,
  ref,
  ...props
}: ComponentPropsWithRef<typeof PopoverPrimitiveContent> & {
  dropdownPanel?: boolean;
  /** When true with dropdownPanel, list scrolls inside the panel frame (long suggestion lists). */
  dropdownPanelScrollable?: boolean;
}) => (
  <PopoverPrimitivePortal>
    <PopoverPrimitiveContent
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      asChild
      {...props}
    >
      <PaperFloating
        surface={dropdownPanel ? "console" : "default"}
        data-dropdown-panel={dropdownPanel ? "" : undefined}
        className={cn(
          dropdownPanel
            ? cn("z-110 outline-none", DROPDOWN_PANEL_SHELL_CLASS)
            : "z-110 w-72 bg-popover p-4 text-popover-foreground outline-none",
          "origin-[--radix-popover-content-transform-origin]",
          RADIX_CONTENT_ANIMATION_CLASSES,
          className,
        )}
      >
        {dropdownPanel && dropdownPanelScrollable ? (
          <DropdownPanelScrollBody>{props.children}</DropdownPanelScrollBody>
        ) : (
          props.children
        )}
      </PaperFloating>
    </PopoverPrimitiveContent>
  </PopoverPrimitivePortal>
);
PopoverContent.displayName = PopoverPrimitiveContent.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
